import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'
import { CHART_COLORS } from '../../../constants/colors'

interface TimelineData {
  year: number
  questionCount: number
  examName?: string
  testCode?: string
}

interface ExamTimelineChartProps {
  data: TimelineData[]
  height?: number
}

export default function ExamTimelineChart({ data, height = 250 }: ExamTimelineChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-gray-500">
        No timeline data available
      </div>
    )
  }

  const chartData = data.sort((a, b) => a.year - b.year)

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={CHART_COLORS.grid} />
        <XAxis dataKey="year" tick={{ fontSize: 12 }} />
        <YAxis tick={{ fontSize: 12 }} allowDecimals={false} />
        <Tooltip
          contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #E5E7EB',
            borderRadius: '8px',
            padding: '8px 12px',
          }}
          content={({ active, payload }) => {
            if (!active || !payload?.length) return null
            const item = payload[0].payload as TimelineData
            return (
              <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-3">
                <p className="font-medium text-gray-900">{item.examName || item.year}</p>
                <p className="text-sm text-gray-600">
                  Questions: <span className="font-medium">{item.questionCount}</span>
                </p>
              </div>
            )
          }}
        />
        <Line
          type="monotone"
          dataKey="questionCount"
          stroke={CHART_COLORS.primary}
          strokeWidth={2}
          dot={{ fill: CHART_COLORS.primary, strokeWidth: 2, r: 4 }}
          activeDot={{ r: 6, stroke: CHART_COLORS.primary, strokeWidth: 2 }}
        />
      </LineChart>
    </ResponsiveContainer>
  )
}
